module.exports = __webpack_public_path__ + "images/1367fd4c3b573447f3044149d6cbfe40a3d313e363c9b84ca03f383fbc3788f3.svg";